// Values belong to whoever is signed in, so the prefix lets sign-in and sign-out drop them all.
const KEY_PREFIX = '$user:';

export const readSessionValue = <T>(key: string, isValid: (value: unknown) => value is T): T | null => {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(KEY_PREFIX + key) ?? 'null');
    return isValid(value) ? value : null;
  } catch {
    return null;
  }
};

export const writeSessionValue = (key: string, value: unknown) => {
  try {
    if (value === null) {
      sessionStorage.removeItem(KEY_PREFIX + key);
    } else {
      sessionStorage.setItem(KEY_PREFIX + key, JSON.stringify(value));
    }
  } catch {
    // Blocked storage: the value just isn't kept.
  }
};

export const clearSessionValues = () => {
  try {
    Object.keys(sessionStorage)
      .filter(key => key.startsWith(KEY_PREFIX))
      .forEach(key => sessionStorage.removeItem(key));
  } catch {
    // Blocked storage: nothing was kept.
  }
};
